<template>
  <header style="background-color: #fff; border-bottom: 1px solid #f2f2f2" class="uk-container uk-container-small uk-margin-top">
    <nav class="uk-navbar-container" uk-navbar>
      <div class="uk-navbar-left">
        <a class="uk-navbar-item uk-logo" href="/">Lab Report</a>
      </div>
      <div class="uk-navbar-right uk-margin-right">
        <span class="uk-margin-small-right" uk-icon="user"></span> <span>{{lab_account}}</span>
      </div>
    </nav>
  </header>
</template>

<script>
  export default {
    name: 'Header',
    props: [
      'lab_account'
    ],
  }
</script>
